import { useAutocompleteContext } from "./AutocompleteContext";
import SuggestionGroup from "./SuggestionGroup";

/**
 * SuggestionList - Renders the dropdown container with grouped suggestions
 */
const SuggestionList: React.FC = () => {
	const { state } = useAutocompleteContext();

	// Don't render if not open or no suggestions
	if (!state.isOpen || state.groupedSuggestions.length === 0) {
		return null;
	}

	// Dynamic classes based on position
	const positionClasses =
		state.position === "above"
			? "absolute bottom-full left-0 right-0 border-b-0 rounded-t"
			: "absolute top-full left-0 right-0 border-t-0 rounded-b";

	// Control visibility to prevent flicker during positioning calculation
	const visibilityStyle = state.isPositioned
		? { opacity: 1, transition: "opacity 0.15s ease-in-out" }
		: { opacity: 0, pointerEvents: "none" as const };

	return (
		<div
			className={`${positionClasses} bg-elevated-1 border border-elevated-2 overflow-y-auto z-50 shadow-lg font-inherit`}
			style={{
				minWidth: "200px", // This should be moved to CSS variables
				maxHeight: `${state.maxHeight}px`,
				...visibilityStyle,
			}}
			role="listbox"
			aria-label="Search suggestions"
			data-testid="autocomplete-suggestions"
		>
			{state.groupedSuggestions.map((group) => (
				<SuggestionGroup key={group.label} group={group} />
			))}
		</div>
	);
};

export default SuggestionList;
